import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { wgw as SearchResults } from '../../../../../redux/actions';


const Input = styled.input.attrs(() => ({
  type: 'text',
}))`
    all: initial;
    background-color: white;
    border: 1px solid #eee;
    padding: 13px 14px;
    border-radius: 4px;
    box-shadow: 0 0 13px -6px #EDEDED;
    display: block;
    width: calc(100% - 62px);
    height: auto;
    box-sizing: content-box;
    padding-left: 50px;
    font-size: 11px;
    font-weight: bold;
    position: absolute;
    color: #404040 !important;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    font-size: 15px !important;
  
    &::placeholder {
      font-size: 11px;
      color: #C7C7C7;
    }
    &::-moz-focus-inner {
      border: 0;
    }

    @media screen and (min-width: 917px) {
      top: 22px;
    }
    
    @media screen and (min-width: 867px) and (max-width: 916px) {
      top: 17px;
    }

    @media screen and (min-width: 810px) and (max-width: 866px) {
      top: 12px;
    }

    @media screen and (min-width: 768px) and (max-width: 809px) {
      top: 8px;
    }

    @media screen and (min-width: 478px) and (max-width: 767px) {
      top: 23px;
    }

    @media screen and (min-width: 449px) and (max-width: 477px) {
      top: 18px;
    }

    @media screen and (min-width: 420px) and (max-width: 448px) {
      top: 12px;
    }

    @media screen and (min-width: 386px) and (max-width: 419px) {
      top: 6px;
    }

    @media screen and (min-width: 321px) and (max-width: 385px) {
      top: 1px;
    }

    @media screen and (max-width: 320px) {
      top: -7px;
    }
`;


const MiloInput = ({
  onSearch,
  setVal,
  value,
  setSearchResults,
  cancelSearch
}) => {
  const searchItem = (e) => {
    setSearchResults([]);
    // Read the input
    const { value } = e.nativeEvent.target;
    if (!value.length) { cancelSearch(); }
    onSearch(value);
    setVal(value);
  };

  return (
    <Input
      id="searchBox"
      title="Search material input"
      aria-label="search material search bar"
      type="text"
      placeholder="Example: Battery"
      value={value}
      onChange={searchItem}
    />
  );
};

const mapStateToProps = (state) => ({
  results: state.wgw.wgwResultsValue
});


const mapDispatchToProps = (dispatch) => ({
  setSearchResults: (value) => dispatch(SearchResults(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(MiloInput);
